__turbopack_context__.v({
  "className": "love_ya_like_a_sister_4ab26221-module__3Dkx8a__className",
});
